import AreaMap from "./AreaMap";

export default AreaMap;
